module.exports = __webpack_public_path__ + "campaign.25938e5bad4d420d73af.png";


//////////////////
// WEBPACK FOOTER
// /Users/bright.ofosu/Documents/brytelabs/seedit-parent/seedit-website/src/assets/images/campaign.png
// module id = ../../../../../src/assets/images/campaign.png
// module chunks = styles